import React from "react";

import NonIdealState from "common/fragments/NonIdealState";
import { ButtonView } from "common/views/button/Button.view";
import PageLinkView from "common/views/pageLink/PageLink.view";
import Query from "core/api/QueryComponent";
import { FragmentLayout } from "core/components/FragmentLayout";
import { IPanelProps, Panel } from "core/decorators/Panel";
import labelProvider from './Catalog.labels';
import * as catalogActions from "./catalogActions";
import CourseDetailsPanelConfig from "./config/CourseDetailsPanelConfig";
import Badge from "./entities/Badge";
import Course from "./entities/Course";
import * as badgeFragments from "./fragments/badge/displayFragments";
import * as courseItemDisplayFragments from "./fragments/course/courseItemDisplayFragments";
import * as courseItemActionFragments from "./fragments/course/courseItemActionFragments";
import * as actionFragments from "./fragments/course/actionFragments";
import * as displayFragments from "./fragments/course/displayFragments";
import * as programFragments from "./fragments/program/displayFragments";
import * as courseItemFragments from "./fragments/courseItem/displayFragments";
import Program from "./entities/Program";
import { Field } from "typegraph";
import { Spinner } from "@blueprintjs/core";
import CourseItem from "./entities/CourseItem";
import { ProductContributor } from "./entities/ProductContributor";
import { RowsView } from "common/views/rows/Rows.view";
import { CardView } from "common/views/card/Card.view";
import { BlockView } from "common/views/block/BlockView.view";
import QueryRoot from "core/api/QueryComponent";

const { Labels } = labelProvider;

const courseFragments = {
	...displayFragments,
	...actionFragments
};

function mapParams(data) {
	const params = {...data}; //clone

	//remove fields which are not using in query
	delete params['loadPrograms'];

	return {params: params};
}

class CourseQuery {

	@Field({
		entity: Course,
		params: mapParams,
		aliasFor: "course_one"
	})
	public course: Course;
}

class CourseItemQuery {

	@Field({
		entity: CourseItem,
		params: mapParams,
		aliasFor: "course_items"
	})
	public courseItems: CourseItem[];
}

const filter : "SUBSCRIBED" | "RECOMMENDED" | "FEATURED" | "BOOKMARKED"= "SUBSCRIBED";


@Panel({ id: 'course-details', configClass: CourseDetailsPanelConfig, labelProvider, pageParams: true})
class CourseDetailsPanel extends React.PureComponent<IPanelProps<CourseDetailsPanelConfig>> {

	private handleReload = (event: any) => {
		if (event.origin !== window.location.origin)
      		return;

		if (event.data==="courseRefresh") {
			console.log("course refresh data="+event.data);
			window.location.reload();
		}
	}

	componentDidMount(){
		window.addEventListener("message", this.handleReload);
	}

	componentWillUnmount() {
		window.removeEventListener("message", this.handleReload);
	}


	public render() {
        const { config, locale, pageParams, searchText, searchIncludesTag } = this.props;
 
        const params: any = {};
 
        if (pageParams['entryId']) {
            params['id'] = pageParams['entryId'];
        } else if (pageParams['externalId']) {
            params['itemExternalId'] = pageParams['externalId'];
        } else {
            return this.renderNotFound();
        }
 
        params['language'] = locale;
        if(pageParams['subscribed']== "true") params['isSubscribed']= true;
        params['includeHidden'] = true;
        params['loadPrograms']=true;
 
        return (
 
            <Query.Root entity={CourseQuery} args={params}>
                {
                    ({data, loading}) => {
 
                        if(loading) {
                            return (
                                <Spinner size={Spinner.SIZE_STANDARD} />
                            );
                        }
                        const course = data && data.course;
 
                        if (!course) {
                            return this.renderNotFound();
                        }
//lazyLoad: course.program && course.program.totalProgress.total >= config.lazyLoadSize && config.lazyLoad,
                        return (
                            // <Query.Many entity={ProductContributor} args={{itemId:course.itemId}}>
                            //     {
                            //         ({ data, loading }) => {
 
                            //             if (loading) {
                            //                 return (
                            //                     <Spinner size={Spinner.SIZE_STANDARD} />
                            //                 );
                            //             }
                            //             const productContributor = data;
                            //             return (
                            <FragmentLayout
                                fragments={courseFragments}
                                layout={config.courseLayout}
                                props={{
                                    course: course,
                                    productContributor: [],
                                    actions: catalogActions,
                                    pageActions: this.props.actions,
                                    trackPaginationVal: this.props.trackPaginationVal,
                                    pageParams: pageParams,
                                    searchText: searchText,
                                    pageSize: config.pageSize,
                                    renderChildCourse: this.renderChildCourse,
                                    renderBadge: this.renderBadge,
                                    renderProgram:this.renderProgram,
                                    lazyLoad: config.lazyLoad,
                                    active: pageParams["searchText"],
                                    handleSearch: this.handleSearch,
                                    handleClear: this.handleClear,
                                    loginBeforeBuy: config.loginBeforeBuy,
                                    renderPackageItems: this.renderPackageItems,
                                    lazyLoadSize: config.lazyLoadSize,
                                    disableDirectBuy: config.disableDirectBuy,
                                    searchIncludesTag: searchIncludesTag
                                }}
                            />
                        //                 )
                        //             }}
                        //     </Query.Many>
                         );
                    }
                }
            </Query.Root>
        );
    }

	private renderChildCourse = (course: Course, launchable: boolean, required: boolean, detailsLinkVisible: boolean) => {
		const { config } = this.props;

		return (
			<FragmentLayout
				fragments={courseFragments}
				layout={config.childrenLayout}
				props={{
					course,
					launchable,
					required,
					detailsLinkVisible,
					actions: catalogActions,
					renderChildCourse: this.renderChildCourse,
					renderBadge: this.renderBadge
				}}
			/>
		);
	}

	private renderBadge = (badge: Badge) => {
		const { config } = this.props;

		return (
			<FragmentLayout
				fragments={badgeFragments}
				layout={config.badgeLayout}
				props={{badge}}
			/>
		);
	}

	private handleSearch = (searchText: string, searchIncludesTag=false) => { // to add search param to url
		this.props.actions.pushPageParams({key: 'searchText', value: searchText});
		if(searchIncludesTag)
			this.props.actions.pushPageParams({key: 'searchIncludesTag', value: searchIncludesTag});
	}
	private handleClear = () => { // to clear search param from url
		this.props.actions.resetProgramPageParams('searchText');
		this.props.actions.resetProgramPageParams('searchIncludesTag');
	}

	private renderPackageItems = (course: Course) => {

		const params: any = {};
		params['entryId'] = course.metaId;
		return ( 
					<Query.Root entity={CourseItemQuery} args={params}>
					{
						({data, loading}) => {

							if(loading) {
								return (
									<Spinner size={Spinner.SIZE_STANDARD} />
								);
							}
							const courseItems = data && data.courseItems;

							if (!courseItems || courseItems.length==0) {
								return null;
							}

							return (
								
								<RowsView viewKey="course.item.rows" key="courseItem.rows">
									{courseItems.map(this.renderPackageItem)}
								</RowsView>
								
							);
						}
					}
				</Query.Root>
		)
	}

	private renderPackageItem = (courseItem: CourseItem) => {
        const { config,locale } = this.props;
        const params = { id: courseItem.entryId }
        params['language'] = locale;
        params['includeHidden'] = true;
        return (
                <QueryRoot.Root entity={CourseQuery} args={params}>
                    {
                        ({data, loading}) => {
 
                            if(loading) {
                                return (
                                    <Spinner size={Spinner.SIZE_STANDARD} />
                                );
                            }
                            const course = data && data.course;
 
                            if (!course) {
                                return <React.Fragment></React.Fragment>;
                            }
                            const courseProps = {
                                course: course,
                                actions: catalogActions,
                            };
                            return (
 
 
                                <CardView viewKey="course.item.card" key={`courseItemCard.${courseItem.title}`}>
                                    <FragmentLayout
                                        layout={config.courseItemLayout}
                                        fragments={{ ...courseItemDisplayFragments, ...courseItemActionFragments }}
                                        props={{ ...courseProps }}
                                    />
                                </CardView>
 
                            );
                        }
                }
                       
            </QueryRoot.Root>
            // <CardView viewKey="course.item.card" key={`courseItemCard.${courseItem.title}`}>
            //  <FragmentLayout
            //      layout={config.courseItemLayout}
            //      fragments={courseItemFragments}
            //      props={{courseItem}}
            //  />
            // </CardView>
        );
    }


	private renderProgram = (program: Program) => {
		const { config } = this.props;

		return (
			<FragmentLayout
				fragments={programFragments}
				layout={config.programLayout}
				props={{
					program,
					loadBadges: true,
					renderBadges: this.renderBadges}}
			/>
		);
	}

	private renderBadges = (badges: Badge[]) => {
		const { config } = this.props;

		return (
			<div>
				{
					badges.map((badge) => {

						return (
							<FragmentLayout
								key={badge.id}
								layout={config.programBadgeLayout}
								fragments={badgeFragments}
								props={{badge}}
							/>
						);
					})
				}
			</div>
		);
	}

	private renderNotFound = () => {
		return (
			<NonIdealState
				title={<Labels.NotFoundTitle />}
				description={<Labels.NotFoundDescription />}
				action={
					<PageLinkView viewKey="exit.link">
						<ButtonView viewKey="exit.button" span={true}>
							<Labels.NotFoundAction />
						</ButtonView>
					</PageLinkView>
				}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/catalog/CourseDetails.panel.tsx